module.exports = __webpack_public_path__ + "static/img/No2.7a4a1ebe.png";